<template>
  <section class="content page-hierarchy-section">
    <div class="container">
      <header v-if="title" class="row justify-between">
        <div class="column flex-auto-fill">
          <h2 class="h1">
            {{ title }}
          </h2>
          <h3 v-if="subheading" class="h4 hidden-xs hidden-sm">
            {{ subheading }}
          </h3>
        </div>
        <div v-if="section && showMore" class="column flex-auto flex-no-shrink">
          <NuxtLink
            :aria-label="moreText"
            :to="{
              path: '/' + computedSection,
              query: { topics: topicsQuery, audiences: audiencesQuery },
            }"
            class="button button--sm button--pale rounded-sm"
          >
            <span class="hidden visible-xs"> All </span>
            <span class="hidden-xs">
              {{ moreText }}
            </span>
            <i class="icon">
              <Icon name="fa6-solid:arrow-right" />
            </i>
          </NuxtLink>
        </div>
      </header>
    </div>
    <slot />
  </section>
</template>

<script setup lang="ts">
const props = withDefaults(
  defineProps<{
    title?: string
    subheading?: string
    section?: string
    filteredTopics?: (string | number)[]
    filteredAudiences?: (string | number)[]
    showMore?: boolean
    moreText?: string
  }>(),
  {
    title: '',
    subheading: '',
    section: '',
    // allows linking to pre-filtered result page
    filteredTopics: () => [],
    // allows linking to pre-filtered result page
    filteredAudiences: () => [],
    showMore: true,
    moreText: 'More from this section',
  },
)

const topicsQuery = computed(() =>
  props.filteredTopics?.length ? props.filteredTopics.join(',') : undefined,
)
const audiencesQuery = computed(() =>
  props.filteredAudiences?.length
    ? props.filteredAudiences.join(',')
    : undefined,
)
const computedSection = computed(() =>
  props.section === 'related' ? 'quick-find' : props.section,
)
</script>

<style lang="less" scoped>
section.page-hierarchy-section {
  padding-top: @9px;
  padding-bottom: 0;

  @media @tablet {
    padding-top: 0;
  }

  header {
    margin-bottom: @gutter-lg;
    border-left: solid @9px @color-secondary;

    @media @desktop {
      .align-end();

      border: none;
    }

    > .column:last-child {
      padding-left: 0;
    }

    > .column:only-child {
      padding-left: 1.125rem !important;
    }

    h2 {
      margin: 0;
      padding-top: @2px;
    }

    h3 {
      .text-body();
      .space(0);

      margin-top: 0.5em; // 9px
      max-width: 60ch;

      @media @tablet {
        margin: 0.75em 0 0; // 12px
      }
    }
  }
}
</style>
